export default __webpack_public_path__ + "static/media/303296f9bcf23501cdcc755eab9bc8a2.svg";